(function () {
  const CONTAINER_SELECTOR = '[data-ps-products], body.template-search motion-list.card-grid, body.template-collection motion-list.card-grid';
  const PRODUCT_SELECTOR = '[data-product-card-priority]';
  const HIDDEN_PART_ATTR = 'data-codex-search-hidden-part';
  const PART_TYPE_PATTERN = /\b(parts?|accessor(y|ies)|spare parts?|replacement parts?)\b/i;
  const EXPLICIT_PART_PATTERN = /\b(spare parts?|replacement parts?|parts? for|for parts?|spare|replacement)\b/i;
  const STRONG_COMPONENT_PATTERN = /\b(receiver|soundboard|throttle|power switch|high\/low switch|steering wheel|steering motor|drive motor|front motor|rear motor|motor cap|controller|control board|front axle|rear axle|axle|shifter|fuse|wiring harness|front bumper|rear bumper|bumper|push handle|foot rest|guard bars?|passenger seat|floor mat|car cover|gearbox)\b/i;
  const FULL_VEHICLE_PATTERN = /\b(ride[-\s]?on|kids ride|power wheels|truck|suv|buggy|utv|atv|tractor|motorcycle|motorbike|dirt bike|go[-\s]?kart|quad|scooter|trike|jeep)\b/i;
  const WEAK_COMPONENT_PATTERN = /\b(charger|battery|remote control|remote|seat belt|pedal)\b/i;
  let pendingRefresh = false;
  const searchCountState = new WeakMap();

  function productText(el) {
    return [
      el.dataset.productType || '',
      el.dataset.productTitle || '',
      el.dataset.productHandle || '',
      el.textContent || '',
    ].join(' ');
  }

  function productRank(el) {
    const type = (el.dataset.productType || '').toLowerCase();
    const text = productText(el).toLowerCase().replace(/[-_]+/g, ' ');
    const hasFullVehicleSignal = FULL_VEHICLE_PATTERN.test(text);
    const isPart =
      PART_TYPE_PATTERN.test(type) ||
      EXPLICIT_PART_PATTERN.test(text) ||
      STRONG_COMPONENT_PATTERN.test(text) ||
      (!type && WEAK_COMPONENT_PATTERN.test(text) && !hasFullVehicleSignal);
    const isUnavailable = el.dataset.productAvailable === 'false';
    return {
      priority: (isPart ? 10 : 0) + (isUnavailable ? 1 : 0),
      isPart,
      originalIndex: Number(el.dataset.codexOriginalIndex || 0),
    };
  }

  function isPartsCollectionContext() {
    const path = window.location.pathname.toLowerCase();
    if (path.replace(/\/+$/, '') === '/search') {
      const params = new URLSearchParams(window.location.search);
      if (params.get('view') === 'parts' || document.getElementById('shopify-section-main-search-parts')) return true;
    }
    if (!path.startsWith('/collections/')) return false;
    return /\b(parts?|spare|replacement|accessor(y|ies))\b/.test(path.replace(/[-_/%]+/g, ' '));
  }

  function isPartsSearchParams(params) {
    return params.get('view') === 'parts';
  }

  function normalizeLegacyVehicleSearchUrl() {
    if (window.location.pathname.replace(/\/+$/, '') !== '/search') return;

    const url = new URL(window.location.href);
    if (isPartsSearchParams(url.searchParams)) return;

    const query = (url.searchParams.get('q') || '').trim();
    if (["(title:motorcycle OR title:motorbike OR title:\"dirt bike\" OR title:MotoX) -product_type:Parts","title:mercedes -product_type:Parts","title:charger -product_type:Parts","(title:\"can-am\" OR title:\"can am\" OR title:canam OR title:maverick) -product_type:Parts","title:maverick -product_type:Parts"].includes(query)) return;
    const cleanQuery = query.replace(/\s*-product_type:parts\b/gi, '').trim();
    if (!cleanQuery || cleanQuery === query) return;
    url.searchParams.set('q', cleanQuery);
    window.location.replace(url.toString());
  }

  function cleanVehicleSearchInputs() {
    if (isPartsCollectionContext()) return;
    document.querySelectorAll('form[action*="/search"] input[name="q"]').forEach((input) => {
      input.value = input.value.replace(/\s*-product_type:parts\b/gi, '').trim();
    });
  }

  function isSearchResultsPage() {
    return document.body.classList.contains('template-search') || window.location.pathname.replace(/\/+$/, '') === '/search';
  }

  function isPredictiveSearchContainer(container) {
    if (!container.matches('[data-ps-products]')) return false;
    if (container.closest('predictive-search, search-drawer, search-modal, [data-predictive-search], .predictive-search, .search-modal')) return true;
    return !document.body.classList.contains('template-collection');
  }

  function shouldHidePartCards(container) {
    return !isPartsCollectionContext() && (isPredictiveSearchContainer(container) || isSearchResultsPage());
  }

  function applyPartVisibility(item, hide) {
    if (hide) {
      item.hidden = true;
      item.setAttribute('aria-hidden', 'true');
      item.setAttribute(HIDDEN_PART_ATTR, 'true');
      return;
    }

    if (item.getAttribute(HIDDEN_PART_ATTR) === 'true') {
      item.hidden = false;
      item.removeAttribute('aria-hidden');
      item.removeAttribute(HIDDEN_PART_ATTR);
    }
  }

  function sortProducts(container) {
    if (!container || container.__codexSorting) return;
    const items = Array.from(container.children).filter((child) => child.matches(PRODUCT_SELECTOR));
    if (!items.length) return;

    container.__codexSorting = true;
    items.forEach((item, index) => {
      if (!item.dataset.codexOriginalIndex) item.dataset.codexOriginalIndex = String(index);
    });

    const hideParts = shouldHidePartCards(container);
    items.forEach((item) => {
      applyPartVisibility(item, hideParts && productRank(item).isPart);
    });

    const sorted = items.slice().sort((a, b) => {
      const rankA = productRank(a);
      const rankB = productRank(b);
      return (
        rankA.priority - rankB.priority ||
        rankA.originalIndex - rankB.originalIndex
      );
    });

    if (!items.every((item, index) => item === sorted[index])) {
      sorted.forEach((el) => container.appendChild(el));
    }
    container.__codexSorting = false;
  }

  function hideLooseSearchParts() {
    if (isPartsCollectionContext()) return;
    document.querySelectorAll('[data-ps-products] > [data-product-card-priority]').forEach((item) => {
      const container = item.parentElement;
      if (!container || !shouldHidePartCards(container)) return;
      applyPartVisibility(item, productRank(item).isPart);
    });
  }

  function sortAllVisible() {
    document.querySelectorAll(CONTAINER_SELECTOR).forEach(sortProducts);
    hideLooseSearchParts();
    refreshSearchPresentation();
  }

  function refreshSearchPresentation() {
    if (!isSearchResultsPage() || isPartsCollectionContext()) return;
    const grid = document.querySelector('main #ProductGridContainer');
    const list = grid?.querySelector('motion-list.card-grid');
    if (!list) return;
    const children = Array.from(list.children);
    const hasHiddenParts = children.some(el => el.getAttribute(HIDDEN_PART_ATTR) === 'true');
    const visibleResults = children.filter(el => el.matches('.product-card, .article-card, .page-card') && !el.hidden).length;
    const counters = document.querySelectorAll('main #ProductCount, main .facet-topbar > [role="status"]');
    counters.forEach(counter => {
      let state = searchCountState.get(counter);
      if (state && counter.textContent !== state.rendered) state = null;
      if (hasHiddenParts) {
        const original = state ? state.original : counter.textContent;
        const rendered = `${visibleResults} ${visibleResults === 1 ? 'result' : 'results'} shown on this page`;
        if (counter.textContent !== rendered) counter.textContent = rendered;
        searchCountState.set(counter, { original, rendered });
      } else if (state) {
        counter.textContent = state.original;
        searchCountState.delete(counter);
      }
    });
    let empty = grid.querySelector('[data-kidsvip-filtered-empty]');
    if (!hasHiddenParts || visibleResults > 0) {
      if (empty) empty.hidden = true;
      return;
    }
    if (!empty) {
      empty = document.createElement('div');
      empty.dataset.kidsvipFilteredEmpty = '';
      empty.className = 'empty-state flex flex-col items-center justify-center text-center gap-6';
      const title = document.createElement('h2');
      title.className = 'heading text-xl';
      title.textContent = 'No results to show on this page';
      const message = document.createElement('p');
      message.textContent = 'Try another search, check Parts, or continue to another results page if available.';
      const link = document.createElement('a');
      link.className = 'button button--primary';
      link.textContent = 'Search Parts';
      empty.append(title, message, link);
      list.before(empty);
    }
    // Count only this page; hidden Parts still occupy native server pagination.
    const partsUrl = new URL('/search', window.location.origin);
    partsUrl.searchParams.set('view', 'parts');
    partsUrl.searchParams.set('type', 'product');
    partsUrl.searchParams.set('filter.p.product_type', 'Parts');
    partsUrl.searchParams.set('q', new URLSearchParams(window.location.search).get('q') || '');
    const link = empty.querySelector('a');
    if (link.href !== partsUrl.href) link.href = partsUrl.href;
    empty.hidden = false;
  }

  function scheduleRefresh() {
    if (pendingRefresh) return;
    pendingRefresh = true;
    requestAnimationFrame(() => {
      pendingRefresh = false;
      observe();
      sortAllVisible();
    });
  }

  function startDocumentObserver() {
    const root = document.documentElement;
    if (!root || root.__psDocumentObserver) return;
    const mo = new MutationObserver(scheduleRefresh);
    mo.observe(root, { childList: true, subtree: true });
    root.__psDocumentObserver = mo;
  }

  document.addEventListener('DOMContentLoaded', () => {
    startDocumentObserver();
    cleanVehicleSearchInputs();
    scheduleRefresh();
  });

  document.addEventListener('predictive-search:render', scheduleRefresh);
  document.addEventListener('shopify:section:load', scheduleRefresh);

  const observe = () => {
    document.querySelectorAll(CONTAINER_SELECTOR).forEach((wrap) => {
      if (wrap.__psObserver) return;
      const mo = new MutationObserver(() => {
        sortProducts(wrap);
        hideLooseSearchParts();
      });
      mo.observe(wrap, { childList: true });
      wrap.__psObserver = mo;
    });
  };

  if (document.readyState !== 'loading') {
    startDocumentObserver();
    cleanVehicleSearchInputs();
    scheduleRefresh();
  }

  normalizeLegacyVehicleSearchUrl();
})();
